import { render, staticRenderFns } from "./jobManage.vue?vue&type=template&id=2a1473c9&scoped=true"
import script from "./jobManage.vue?vue&type=script&lang=js"
export * from "./jobManage.vue?vue&type=script&lang=js"
import style0 from "./jobManage.vue?vue&type=style&index=0&id=2a1473c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1473c9",
  null
  
)

export default component.exports